import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Mask} from 'react-weui';

import '../../styles/classroom/ClassroomGuide.css';
import normalGd1 from '../../images/lecture/normal-yd1.png';
import normalGd2 from '../../images/lecture/normal-yd2.png';
import normalGd3 from '../../images/lecture/normal-yd3.png';
import pptGd1 from '../../images/lecture/ppt-yd1.png';
import pptGd2 from '../../images/lecture/ppt-yd2.png';
import pptGd3 from '../../images/lecture/ppt-yd3.png';


class ClassroomGuide extends Component {
    constructor() {
        super();

        this.handleGuide = this.handleGuide.bind(this);
        this.state = {
            num: 1,
            normalGuideMap: {1: normalGd1, 2: normalGd2, 3: normalGd3},
            pptGuideMap: {1: pptGd1, 2: pptGd2, 3: pptGd3},
            show: true,
        }
    }

    componentWillMount() {
        const {lectureMode, role} = this.props;
        let {imageMode} = this.props;
        if (['video', 'audio'].indexOf(imageMode) > -1 || imageMode === 'ppt') {
            imageMode = 'ppt'
        } else {
            imageMode = 'image'
        }
        const key = imageMode + 'Guide';
        const flag = !localStorage.getItem(key) || (localStorage.getItem(key) && +localStorage[imageMode + 'GuideNum'] < 2);

        if (role.is_manager || role.is_lecturer) {
            return;
        }
        if (flag) {
            localStorage.setItem(key, true);
            localStorage[imageMode + 'GuideNum'] = localStorage[imageMode + 'GuideNum'] ? (+localStorage[imageMode + 'GuideNum'] + 1) : 1;
        } else {
            this.setState({show: false});
        }
    }

    handleGuide() {
        this.setState({num: ++this.state.num});
    }

    render() {
        const {imageMode, lectureMode, role} = this.props;
        const {normalGuideMap, pptGuideMap, num, show} = this.state;
        let content = {};
        let type = '';
        if (['video', 'audio'].indexOf(imageMode) > -1 || imageMode === 'ppt') {
            content = pptGuideMap;
            type = 'ppt';
        } else {
            content = normalGuideMap;
            type = 'image';
        }

        if (!content[num] || role.is_manager || role.is_lecturer || !show) {
            return null;
        }
        return (
            <div>
                <Mask/>
                {type === 'ppt' &&
                <div className="classroom-guide ppt-guide" onClick={this.handleGuide}>
                    <img src={pptGd1} className={num === 1 ? "wk-show" : "wk-hide"}/>
                    <img src={pptGd2} className={num === 2 ? "wk-show" : "wk-hide"}/>
                    <img src={pptGd3} className={num === 3 ? "wk-show" : "wk-hide"}/>
                </div>
                }

                {type === 'image' &&
                <div className="classroom-guide image-guide" onClick={this.handleGuide}>
                    <img src={normalGd1} className={num === 1 ? "wk-show" : "wk-hide"}/>
                    <img src={normalGd2} className={num === 2 ? "wk-show" : "wk-hide"}/>
                    <img src={normalGd3} className={num === 3 ? "wk-show" : "wk-hide"}/>
                </div>
                }
            </div>
        )
    }
}

export default connect((state) => ({
    lectureMode: state.classroom.lecture.lecture_mode,
    imageMode: state.classroom.lecture.image_mode,
    role: state.classroom.role,
}))(ClassroomGuide)


// WEBPACK FOOTER //
// ./src/components/classroom/ClassroomGuide.js